export var ImageMode = {
    Landscape: 'landscape',
    Portrait: 'portrait'
};
